import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./chennaimadh.css";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaCalendarCheck,
  FaLeaf,
  FaTooth,
  FaHospital,
  FaArrowRight,
  FaCheckCircle,
  FaGlobe,
  FaWhatsapp,
  FaClock,
  FaStar,
  FaUserMd,
  FaAward,
  FaHeartbeat,
  FaRegLightbulb,
  FaShieldAlt,
  FaCertificate,
  FaUserCheck,
  FaCoins,
  FaUserShield,
  FaWallet,
  FaCheck,
  FaLocationArrow,
  FaDirections,
} from "react-icons/fa";
import { GiHairStrands, GiMedicalDrip, GiMedicalPack } from "react-icons/gi";
import {
  MdFace,
  MdHealthAndSafety,
  MdOutlineHealthAndSafety,
  MdSupportAgent,
} from "react-icons/md";
import { RiMentalHealthFill } from "react-icons/ri";
import { BiBody } from "react-icons/bi";
import tambaramskin from "../../../assets/images/tambaramskinicon.png";
import tambaramhair from "../../../assets/images/tambaramhairicon1.png";
import tambaramleaf from "../../../assets/images/tambaramleaf.jpg";
import tambarambanner3 from "../../../assets/images/tambarambanner4.png";
// Import combined Before-After images
import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";

import img11 from "../../../assets/images/autoscrollskin1.png";
import img12 from "../../../assets/images/autoscrollskin2.png";
import img13 from "../../../assets/images/autoscrollskin3.png";
import img14 from "../../../assets/images/autoscrollskin4.png";
import img15 from "../../../assets/images/autoscrollskin5.png";
import img16 from "../../../assets/images/autoscrollskin6.png";
import img17 from "../../../assets/images/autoscrollskin7.png";
import img18 from "../../../assets/images/autoscrollskin8.png";
import img19 from "../../../assets/images/autoscrollskin9.png";
import img20 from "../../../assets/images/autoscrollskin10.png";

import chennaitambarm from "../../../assets/images/chennaitambarmhair.jpg";
import chennaitambarmskin from "../../../assets/images/chennaitambaramskin.jpg";
import chennaitambaramhomeopathy from "../../../assets/images/chennaitambaramhomeopathy1.jpg";
import chennaitambaramskin1 from "../../../assets/images/chennaitambaramskin1.jpg";
import chennaitambaramskin2 from "../../../assets/images/chennaitambaramskin2.jpg";
import chennaitambaramprp from "../../../assets/images/chennaitambaramprp.jpg";
import chennaitambaramgfc from "../../../assets/images/chennaitambaramgfc1.jpg";
import chennaitambaramantiage from "../../../assets/images/chennaitambaramantiaging1.jpg";
import chennaitambaramanstm from "../../../assets/images/chennaitambaramstm1.jpg";
import chennaitambaramandental from "../../../assets/images/chennaitambarmdental.jpg";
import chennaitambaramandental1 from "../../../assets/images/chennaitambaramandental2.jpg";
import chennaitambaramandental2 from "../../../assets/images/chennaitambaramandental3.jpg";
import chennaitambaramandental3 from "../../../assets/images/chennaitambaramandental4.jpg";
import chennaitambarammaindental from "../../../assets/images/chennaaitambarammaindental.jpg";
import chennaitambaramdentalinvisible from "../../../assets/images/chennaitambaramdentalinvisible.jpg";
import chennaitambarampcos from "../../../assets/images/chennaitambarampcos.jpg";
import chennaitambaramchronic from "../../../assets/images/chennaitambaramchronic.png";
import chennaitambarammentalhealth from "../../../assets/images/chennaitambarammentalhealth.jpg";
import chennaitambaramprpmicroneeding from "../../../assets/images/chennaitambaramprpmicroneeding1.jpg";
import chennaitambaramhairplan from "../../../assets/images/chennaitambaramhairplan.jpg";
import chennaitambaramlaserhair from "../../../assets/images/chennaitambaramlaserhair1.jpg";
import chennaitambarammainskin from "../../../assets/images/chennaitambarammainskin.jpg";
import chennaitambaramskinwhite from "../../../assets/images/chennaitambaramskinwhite.jpg";
import chennaitambaramhomeopathy1 from "../../../assets/images/chennaitambaramalopecia.jpg";
import chennaitambaramanxeity from "../../../assets/images/chennaitambaramanxeity.jpg";
import chennaitambarampiles from "../../../assets/images/chennaitambarampiles.jpg";
import chennaitambarammainhair from "../../../assets/images/chennaitamabarammainhair.jpg";
import chennaitambarammenqr678 from '../../../assets/images/chennaitambaramqr678.jpg';

import hcuraHeroVideo1 from "../../../assets/video/hcura-hero6.mp4";
import hcuraHeroVideo2 from "../../../assets/video/hcura-hero4.mp4";
import hcuraHeroVideo from "../../../assets/video/hcura-hero2.mp4";

// SEO Schema Component
const SchemaMarkup = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    name: "H-Cura Multispecialty Clinic Gerugambakkam",
    description:
      "Premier healthcare clinic in Gerugambakkam Chennai offering Hair Treatment, Skin Care, Dental Services, and Homeopathy. Expert doctors, advanced technology, affordable care.",
    url: "https://h-cura.com/gerugambakkam-clinic",
    telephone: "+91-99646-88333",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
      addressLocality: "Gerugambakkam",
      addressRegion: "Tamil Nadu",
      postalCode: "600128",
      addressCountry: "IN",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "13.0067",
      longitude: "80.1556",
    },
    openingHours: "Mo-Sa 10:00-20:00, Su 10:00-13:00",
    medicalSpecialty: ["Dermatology", "Trichology", "Dentistry", "Homeopathy"],
    priceRange: "$$",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      reviewCount: "500",
    },
  };

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
};

const ICON_MAP = {
  "quality-icon": FaAward,
  "personalized-icon": FaUserCheck,
  "affordable-icon": FaCoins,
};

const Icon = ({ name, size = 24, className = "", ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const HCuraChennai = () => {
  const [activeLocation, setActiveLocation] = useState("gerugambakkam");
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);
useEffect(() => {
  document.title = "H-Cura Multispecialty Clinic Gerugambakkam Chennai - Hair, Skin, Dental & Homeopathy Treatments";
  
  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute(
      "content",
      "Premier healthcare clinic in Gerugambakkam Chennai offering advanced Hair Fall Treatment, Skin Whitening, Dental Care & Natural Homeopathy. Expert doctors, modern technology, affordable care for women's health. Serving Porur, Mangadu, Moulivakkam areas."
    );
  }
  
  const metaKeywords = document.querySelector("meta[name='keywords']");
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "Multispeciality clinic Gerugambakkam Chennai, Hair clinic Gerugambakkam, Skin care clinic Gerugambakkam, Homeopathy clinic Gerugambakkam, Dental clinic Gerugambakkam, Advanced hair treatment Gerugambakkam, Hair fall treatment Chennai, PRP hair therapy Gerugambakkam, GFC hair therapy Gerugambakkam, Exosome hair treatment Gerugambakkam, Skin care treatment Chennai, Anti-aging treatment Gerugambakkam, HydraFacial Chennai, Acne treatment Chennai, Hair growth treatment Chennai, Cosmetic dermatology Gerugambakkam, Holistic homeopathy Chennai, Chronic illness homeopathy Chennai, Allergy treatment Gerugambakkam, Painless dental treatment Chennai, Dental implants Gerugambakkam, Teeth whitening Chennai, Orthodontics Gerugambakkam, Oral health Chennai, Best clinic in Gerugambakkam, H-Cura clinic Gerugambakkam",
    );
  }
  
  // Set canonical link
  const existingCanonical = document.querySelector("link[rel='canonical']");
  if (existingCanonical) {
    existingCanonical.setAttribute("href", "https://h-cura.com/multispecialty-clinic-in-gerugambakkam-chennai");
  } else {
    const canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", "https://h-cura.com/multispecialty-clinic-in-gerugambakkam-chennai");
    document.head.appendChild(canonicalLink);
  }
  
  // Set favicon (if you have one)
  // const existingFavicon = document.querySelector("link[rel='icon']");
  // if (existingFavicon) {
  //   existingFavicon.setAttribute("href", "/favicon.ico");
  // } else {
  //   const faviconLink = document.createElement("link");
  //   faviconLink.setAttribute("rel", "icon");
  //   faviconLink.setAttribute("type", "image/x-icon");
  //   faviconLink.setAttribute("href", "/favicon.ico");
  //   document.head.appendChild(faviconLink);
  // }
}, []);

  // Auto-scroll state and ref
  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  // Modal viewer state for Gerugambakkam
  const [gerugambakkamBaModalOpen, setGerugambakkamBaModalOpen] =
    useState(false);
  const [gerugambakkamBaModalItems, setGerugambakkamBaModalItems] = useState(
    []
  );
  const [gerugambakkamBaModalStartIndex, setGerugambakkamBaModalStartIndex] =
    useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Gallery scrolling functions
  const scrollGallery = (direction) => {
    const container = document.getElementById("scrollableGrid");
    const cardWidth = 420;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    let newScrollPosition;
    if (direction === "next") {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }

    container.scrollTo({
      left: newScrollPosition,
      behavior: "smooth",
    });

    updateScrollIndicators();
  };

  const updateScrollIndicators = () => {
    const container = document.getElementById("scrollableGrid");
    const progressBar = document.getElementById("progressBar");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    if (!container || !progressBar) return;

    const scrollPercentage =
      (container.scrollLeft / (container.scrollWidth - container.clientWidth)) *
      100;
    progressBar.style.width = `\${scrollPercentage}%`;

    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn)
      nextBtn.disabled =
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth - 10;
  };

  useEffect(() => {
    if (gerugambakkamBaModalOpen) {
      const container = document.getElementById("scrollableGrid");
      if (container) {
        container.addEventListener("scroll", updateScrollIndicators);
        updateScrollIndicators();

        const cardWidth = 420;
        container.scrollLeft = gerugambakkamBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener("scroll", updateScrollIndicators);
        };
      }
    }
  }, [gerugambakkamBaModalOpen, gerugambakkamBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start("visible");
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Auto-advance services every 10 seconds
  useEffect(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService((prev) => {
          const next = (prev + 1) % advancedServices.length;
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000);
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const locations = {
    tambaram: {
      name: "Tambaram",
      address:
        "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
      phone: "+91 88700 01377",
      hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
      nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
      popularServices: [
        "PRP Hair Treatment",
        "Dental Fillings",
        "Acne & Skin Lightening",
        "Root Canal and Smile Design",
      ],
      specialties: "Hair Restoration & Dental Procedures",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai",
      video: hcuraHeroVideo1,
    },
    valasaravakkam: {
      name: "Valasaravakkam",
      address:
        "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
      phone: "+91 88700 01377",
      hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
      nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
      popularServices: [
        "Braces and Orthodontics",
        "GFC Hair Therapy",
        "Pigmentation & Skin Whitening",
        "Anxiety & PCOS Homeopathy Treatment",
      ],
      specialties: "Skin Treatments & Women's Health",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai",
      video: hcuraHeroVideo1,
    },
    gerugambakkam: {
      name: "Gerugambakkam",
      address:
        "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
      phone: "+91 88700 01377",
      hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
      nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
      popularServices: [
        "Hair Loss Treatment",
        "Skin Problem Solutions",
        "Complete Dental Care",
        "Natural Homeopathy Treatment",
      ],
      specialties: "Complete Healthcare Solutions",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai",
      video: hcuraHeroVideo1,
    },
  };

 const advancedServices = [
    {
      id: 'hair',
      title: 'Hair Treatments in Gerugambakkam – Get Your Hair Back',
      subtitle: 'Stop Hair Loss, Grow New Hair',
      description: 'Get your hair back with Gerugambakkam\'s best hair treatments. Our doctors use safe, proven methods like PRP and GFC to help your hair grow naturally. See real results in just a few months.',
      image: chennaitambarm,
      treatments: [
        {
          name: 'PRP Hair Treatment Gerugambakkam',
          description: 'Use your own blood to make your hair grow stronger and thicker. This safe treatment helps stop hair loss and grows new hair naturally.',
          icon: 'prp-icon',
          image: chennaitambaramprp,
          benefits: ['Makes hair grow naturally', 'Makes hair roots stronger', 'No surgery needed', 'Quick recovery time']
        },
        {
          name: 'GFC Hair Treatment Gerugambakkam',
          description: 'Advanced treatment that uses special growth factors to make your hair grow faster and become thicker than before.',
          icon: 'gfc-icon',
          image: chennaitambaramgfc,
          benefits: ['Hair grows faster', 'Hair becomes thicker', 'Looks completely natural', 'Treatment made just for you']
        },
        {
          name: 'Qr678 Gerugambakkam',
          description: 'New treatment using natural plant medicines to help your hair grow back. You can see good results in just a few sessions.',
          icon: 'prp-icon',
          image: chennaitambarammenqr678,
          benefits: ['No surgery needed', 'Made from natural plants', 'See results quickly', 'Completely safe']
        }
      ],
      testimonial: {
        quote: "The hair treatment at H-Cura Gerugambakkam was amazing. My hair looks so much better now and I feel confident again!",
        author: "Arjun R.",
        location: "Anna Nagar"
      }
    },
    {
      id: 'skin',
      title: 'Skin Treatments in Gerugambakkam – Clear, Healthy Skin',
      subtitle: 'Fix Skin Problems, Look Younger',
      description: 'Get clear, healthy skin with our safe treatments. We help with acne, dark spots, wrinkles, and other skin problems using modern technology that really works.',
      image: chennaitambarmskin,
      treatments: [
        {
          name: 'HydraFacial in Gerugambakkam',
          description: 'Special facial treatment that cleans your skin deeply and makes it glow instantly. Your skin will look fresh and healthy right away.',
          icon: 'pigmentation-icon',
          image: chennaitambaramskin1,
          benefits: ['Cleans skin deeply', 'Instant glow', 'No recovery time needed', 'Special serums for your skin']
        },
        {
          name: 'Laser Skin Treatment Gerugambakkam',
          description: 'Safe laser treatment that removes dark spots, acne scars, and makes your skin look young and fresh again.',
          icon: 'pigmentation-icon',
          image: chennaitambaramskin2,
          benefits: ['Removes dark spots', 'Makes skin color even', 'Makes skin smooth', 'Results last long time']
        },
        {
          name: 'Anti-Aging Treatment Gerugambakkam',
          description: 'Complete treatment to make you look younger. Reduces wrinkles and makes your skin tight and smooth.',
          icon: 'pigmentation-icon',
          image: chennaitambaramantiage,
          benefits: ['Reduces wrinkles', 'Makes skin tight', 'Helps make more collagen', 'Looks completely natural']
        }
      ],
      testimonial: {
        quote: "The laser treatment for my skin problems at H-Cura Gerugambakkam changed my life. My skin looks amazing now!",
        author: "Priya S.",
        location: "Adyar"
      }
    },
    {
      id: 'dental',
      title: 'Dental Care in Gerugambakkam – Healthy Teeth & Beautiful Smile',
      subtitle: 'Fix Teeth Problems, Get Perfect Smile',
      description: 'Get healthy teeth and a beautiful smile with our modern dental treatments. We make dental care comfortable and give you the smile you always wanted.',
      image: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      treatments: [
        {
          name: 'Digital Smile Design Gerugambakkam',
          description: 'See how your new smile will look before we start treatment. We use computer technology to plan your perfect smile.',
          icon: 'smile-icon',
          image: chennaitambaramandental,
          benefits: ['See results before treatment', 'Plan made just for you', 'Very accurate treatment', 'Beautiful results']
        },
        {
          name: 'Dental Implants Gerugambakkam',
          description: 'Replace missing teeth with new teeth that look and feel completely natural. These new teeth will last for many years.',
          icon: 'rootcanal-icon',
          image: chennaitambaramandental1,
          benefits: ['Permanent solution', 'Looks like real teeth', 'Keeps jaw bone healthy', 'Lasts very long time']
        },
        {
          name: 'Invisible Braces Gerugambakkam',
          description: 'Straighten your teeth with clear braces that no one can see. Comfortable and easy to remove when eating.',
          icon: 'aligner-icon',
          image: chennaitambaramdentalinvisible,
          benefits: ['Almost invisible', 'Can remove when eating', 'Very comfortable', 'Need fewer visits']
        }
      ],
      testimonial: {
        quote: "The digital smile design at H-Cura Gerugambakkam let me see my new smile first. The final result is even better than I expected!",
        author: "Vikram K.",
        location: "T. Nagar"
      }
    },
    {
      id: 'homeopathy',
      title: 'Homeopathy in Gerugambakkam – Natural Healing for Good Health',
      subtitle: 'Natural Medicine, Complete Wellness',
      description: "Get better health naturally with homeopathy. Our experienced doctors treat health problems like PCOS, diabetes, and stress using safe, natural medicines that work.",
      image: chennaitambaramhomeopathy,
      treatments: [
        {
          name: 'PCOS Treatment Gerugambakkam',
          description: 'Natural treatment for PCOS that helps balance your hormones and makes your periods regular without side effects.',
          icon: 'constitutional-icon',
          image: chennaitambarampcos,
          benefits: ['Treats the main problem', 'Complete natural approach', 'Medicine made for you', 'Good for long-term health']
        },
        {
          name: 'Chronic Disease Treatment Gerugambakkam',
          description: 'Natural treatment for long-term health problems like diabetes, blood pressure, and joint pain using safe homeopathy.',
          icon: 'hormonal-icon',
          image: chennaitambaramchronic,
          benefits: ['Need less regular medicines', 'Feel better every day', 'Fixes root causes', 'Safe for everyone']
        },
        {
          name: 'Mental Health & Wellness Gerugambakkam',
          description: 'Natural treatment for stress, worry, depression, and sleep problems using gentle homeopathic medicines.',
          icon: 'chronic-icon',
          image: chennaitambarammentalhealth,
          benefits: ['Feel happier naturally', 'Less stress and worry', 'Sleep better', 'Feel emotionally balanced']
        }
      ],
      testimonial: {
        quote: "The homeopathic treatment for my stress at H-Cura Gerugambakkam changed my life. I feel so much better now and it's completely natural!",
        author: "Divya M.",
        location: "Velachery"
      }
    }
  ];


  const testimonials = [
    {
      name: "Priya R.",
      location: "Gerugambakkam",
      text: "The hair treatment at H-Cura Gerugambakkam gave me amazing results. The doctors are very caring and the treatment was completely painless.",
      rating: 5,
      service: "Hair Treatment",
    },
    {
      name: "Karthik M.",
      location: "Porur",
      text: "Best skin treatment in Gerugambakkam! My acne problem is completely solved and my skin looks so much better now.",
      rating: 5,
      service: "Skin Treatment",
    },
    {
      name: "Divya S.",
      location: "Mangadu",
      text: "The dental care at H-Cura Gerugambakkam is excellent. The root canal was completely painless and the staff is very professional.",
      rating: 5,
      service: "Dental Care",
    },
  ];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Prime Gerugambakkam Location",
      description:
        "Located in the heart of Gerugambakkam, our clinic is easily accessible from Porur, Mangadu, Moulivakkam, and surrounding areas with excellent connectivity.",
      highlight: "Easy Access",
    },
    {
      icon: <FaUserMd />,
      title: "Expert Specialists",
      description:
        "Our team of experienced doctors specializes in Hair Treatment, Skin Care, Dental Solutions, and Homeopathy with years of expertise in women's health.",
      highlight: "Specialized Care",
    },
    {
      icon: <GiMedicalPack />,
      title: "Advanced Technology",
      description:
        "We use the latest medical equipment and proven techniques for PRP Hair Treatment, Skin Whitening, Digital Dentistry, and Natural Homeopathy.",
      highlight: "Modern Equipment",
    },
    {
      icon: <FaHeartbeat />,
      title: "Women's Health Focus",
      description:
        "Special expertise in PCOS/PCOD treatment, skin whitening, and women's health issues using safe, natural homeopathic remedies.",
      highlight: "Women's Wellness",
    },
    {
      icon: <FaAward />,
      title: "Proven Results",
      description:
        "Hundreds of satisfied patients from Gerugambakkam and nearby areas trust us for effective treatments with visible, lasting results.",
      highlight: "Success Stories",
    },
    {
      icon: <FaRegLightbulb />,
      title: "Personalized Care",
      description:
        "Every treatment plan is customized based on individual needs, ensuring the best possible outcomes for each patient.",
      highlight: "Tailored Treatments",
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: "Safety Standards",
      description:
        "Strict hygiene protocols, sterilized equipment, and international safety standards ensure your complete safety during all treatments.",
      highlight: "Medical Safety",
    },
    {
      icon: <MdSupportAgent />,
      title: "Continuous Support",
      description:
        "Regular follow-ups, patient education, and dedicated support throughout your treatment journey for optimal results.",
      highlight: "Patient Support",
    },
  ];

  const testimonialQuotes = [
    "H-Cura Gerugambakkam truly understands women's health needs and provides personalized care.",
    "The best clinic in Gerugambakkam for natural treatments that actually work.",
    "Their focus on safety and natural healing makes them stand out in Chennai.",
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case "hair":
        return "/advanced-grow-hair-treatment";
      case "skin":
        return "/advanced-hydrafacial-treatment";
      case "dental":
        return "/dental-treatment";
      case "homeopathy":
        return "/homeopathy-best-treatments/";
      default:
        return "/services";
    }
  };

  // Image and icon management
  const heroBackgroundUrl = tambarambanner3;
  const servicesBackgroundUrl =
    "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80";

  const serviceIconMap = {
    hair: {
      url: tambaramhair,
      bgColor: "rgba(255,154,158,0.12)",
      borderColor: "rgba(255,154,158,0.18)",
      color: "#ff4d6d",
    },
    skin: {
      url: tambaramskin,
      bgColor: "rgba(255,223,121,0.12)",
      borderColor: "rgba(255,223,121,0.18)",
      color: "#ffb400",
    },
    dental: {
      url: "https://img.icons8.com/fluency/48/000000/tooth.png",
      bgColor: "rgba(144,238,144,0.12)",
      borderColor: "rgba(144,238,144,0.18)",
      color: "#28a745",
    },
    homeopathy: {
      url: tambaramleaf,
      bgColor: "rgba(135,206,250,0.12)",
      borderColor: "rgba(135,206,250,0.18)",
      color: "#0099cc",
    },
  };

  const treatmentIconMap = {
    "prp-icon": {
      url: "https://img.icons8.com/fluency/48/000000/syringe.png",
      bgColor: "rgba(255,140,140,0.06)",
      borderColor: "rgba(255,140,140,0.12)",
    },
    "gfc-icon": {
      url: "https://img.icons8.com/fluency/48/000000/biotech.png",
      bgColor: "rgba(170,200,255,0.06)",
      borderColor: "rgba(110,160,255,0.12)",
    },
    "transplant-icon": {
      url: "https://img.icons8.com/fluency/48/000000/hair-care.png",
      bgColor: "rgba(255,230,140,0.06)",
      borderColor: "rgba(255,200,60,0.12)",
    },
    "hydrafacial-icon": {
      url: "https://img.icons8.com/fluency/48/000000/spa-care.png",
      bgColor: "rgba(200,255,230,0.06)",
      borderColor: "rgba(60,200,120,0.12)",
    },
    "pigmentation-icon": {
      url: "https://img.icons8.com/fluency/48/000000/foundation-makeup.png",
      bgColor: "rgba(250,210,255,0.06)",
      borderColor: "rgba(220,120,240,0.12)",
    },
    "antiaging-icon": {
      url: "https://img.icons8.com/fluency/48/000000/collagen.png",
      bgColor: "rgba(220,245,255,0.06)",
      borderColor: "rgba(80,200,240,0.12)",
    },
    "smile-icon": {
      url: "https://img.icons8.com/fluency/48/000000/happy-tooth.png",
      bgColor: "rgba(200,255,220,0.06)",
      borderColor: "rgba(80,200,120,0.12)",
    },
    "rootcanal-icon": {
      url: "https://img.icons8.com/fluency/48/000000/tooth-cleaning.png",
      bgColor: "rgba(255,240,200,0.06)",
      borderColor: "rgba(240,180,60,0.12)",
    },
    "aligner-icon": {
      url: "https://img.icons8.com/fluency/48/000000/braces.png",
      bgColor: "rgba(230,230,255,0.06)",
      borderColor: "rgba(140,120,240,0.12)",
    },
    "constitutional-icon": {
      url: "https://img.icons8.com/fluency/48/000000/holistic-therapy.png",
      bgColor: "rgba(240,240,255,0.06)",
      borderColor: "rgba(160,160,240,0.12)",
    },
    "hormonal-icon": {
      url: "https://img.icons8.com/fluency/48/000000/hormone.png",
      bgColor: "rgba(255,230,240,0.06)",
      borderColor: "rgba(240,160,200,0.12)",
    },
    "chronic-icon": {
      url: "https://img.icons8.com/fluency/48/000000/medical-pack.png",
      bgColor: "rgba(230,255,240,0.06)",
      borderColor: "rgba(160,240,200,0.12)",
    },
  };

  // Gallery with proper titles and descriptions
  const SAMPLE_GALLERY = {
    hair: [
      {
        id: "hair-1",
        title: "Hair Restoration Case 1 - Male Pattern Hair Loss Treatment",
        combined: img1,
        testimonial: {
          quote:
            "Amazing hair transformation in Gerugambakkam with PRP treatment!",
          author: "Rajesh K.",
        },
      },
      {
        id: "hair-2",
        title: "Hair Restoration Case 2 - Female Hair Thinning Solution",
        combined: img2,
        testimonial: {
          quote:
            "PRP and GFC therapy at H-Cura Gerugambakkam gave incredible results!",
          author: "Amit S.",
        },
      },
      {
        id: "hair-3",
        title: "Hair Restoration Case 3 - Receding Hairline Treatment Success",
        combined: img3,
        testimonial: {
          quote:
            "My confidence returned with natural-looking hairline restoration!",
          author: "Priya M.",
        },
      },
      {
        id: "hair-4",
        title: "Hair Restoration Case 4 - Complete Hair Regrowth Journey",
        combined: img4,
        testimonial: {
          quote:
            "GFC therapy worked wonders for my extensive hair loss problem.",
          author: "Karthik R.",
        },
      },
      {
        id: "hair-5",
        title: "Hair Restoration Case 5 - Natural Hair Density Improvement",
        combined: img5,
        testimonial: {
          quote:
            "Best decision for my hair health. Natural results in Gerugambakkam!",
          author: "Deepak V.",
        },
      },
      {
        id: "hair-6",
        title: "Hair Restoration Case 6 - Hair Volume Enhancement Treatment",
        combined: img6,
        testimonial: {
          quote: "Visible hair density increase within 3 months of treatment.",
          author: "Anitha L.",
        },
      },
      {
        id: "hair-7",
        title: "Hair Restoration Case 7 - Complete Hair Transformation Success",
        combined: img7,
        testimonial: {
          quote:
            "Professional treatment with amazing outcomes. Thank you H-Cura!",
          author: "Suresh K.",
        },
      },
      {
        id: "hair-8",
        title: "Hair Restoration Case 8 - Hairline Restoration Excellence",
        combined: img8,
        testimonial: {
          quote: "My family is amazed by the complete hair transformation.",
          author: "Vikram P.",
        },
      },
      {
        id: "hair-9",
        title:
          "Hair Restoration Case 9 - Hair Volume and Thickness Enhancement",
        combined: img9,
        testimonial: {
          quote: "H-Cura Gerugambakkam gave me back my youthful appearance!",
          author: "Ramesh B.",
        },
      },
      {
        id: "hair-10",
        title: "Hair Restoration Case 10 - Advanced Hair Treatment Results",
        combined: img10,
        testimonial: {
          quote: "Outstanding results that exceeded all my expectations!",
          author: "Mahesh T.",
        },
      },
    ],

    skin: [
      {
        id: "skin-1",
        title: "Skin Treatment Case 1 - Acne Clearance and Skin Healing",
        combined: img11,
        testimonial: {
          quote: "Clear, healthy skin after years of struggling with acne!",
          author: "Sneha R.",
        },
      },
      {
        id: "skin-2",
        title: "Skin Treatment Case 2 - Pigmentation Removal Success Story",
        combined: img12,
        testimonial: {
          quote: "HydraFacial in Gerugambakkam gave me the perfect glow!",
          author: "Kavya M.",
        },
      },
      {
        id: "skin-3",
        title: "Skin Treatment Case 3 - Anti-Aging Treatment Transformation",
        combined: img13,
        testimonial: {
          quote:
            "Wrinkles reduced significantly with advanced laser treatment.",
          author: "Meera K.",
        },
      },
      {
        id: "skin-4",
        title: "Skin Treatment Case 4 - Skin Whitening and Brightening Results",
        combined: img14,
        testimonial: {
          quote: "Even, bright skin tone achieved naturally and safely.",
          author: "Preethi S.",
        },
      },
      {
        id: "skin-5",
        title: "Skin Treatment Case 5 - Melasma Treatment Success",
        combined: img15,
        testimonial: {
          quote:
            "Dark patches completely gone after treatment in Gerugambakkam!",
          author: "Divya L.",
        },
      },
      {
        id: "skin-6",
        title: "Skin Treatment Case 6 - Complete Skin Rejuvenation Journey",
        combined: img16,
        testimonial: {
          quote: "Youthful skin restored with advanced treatment techniques.",
          author: "Anjali P.",
        },
      },
      {
        id: "skin-7",
        title: "Skin Treatment Case 7 - Acne Scar Removal Excellence",
        combined: img17,
        testimonial: {
          quote:
            "Smooth skin texture achieved after professional scar treatment.",
          author: "Rohit M.",
        },
      },
      {
        id: "skin-8",
        title: "Skin Treatment Case 8 - Dark Circle Treatment Success",
        combined: img18,
        testimonial: {
          quote: "Bright, refreshed eyes after under-eye treatment.",
          author: "Lakshmi V.",
        },
      },
      {
        id: "skin-9",
        title: "Skin Treatment Case 9 - Skin Tightening and Firming Results",
        combined: img19,
        testimonial: {
          quote: "Firm, tight skin without surgery. Amazing results!",
          author: "Sunita K.",
        },
      },
      {
        id: "skin-10",
        title: "Skin Treatment Case 10 - Complete Skin Health Transformation",
        combined: img20,
        testimonial: {
          quote: "Complete skin transformation with holistic care approach.",
          author: "Ravi S.",
        },
      },
    ],

    dental: [
      {
        id: "dental-1",
        title: "Dental Treatment Case 1 - Complete Smile Makeover Success",
        combined:
          "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Perfect smile achieved with digital smile design in Gerugambakkam!",
          author: "Arun K.",
        },
      },
      {
        id: "dental-2",
        title: "Dental Treatment Case 2 - Teeth Whitening Transformation",
        combined:
          "https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Bright, white teeth achieved in just one session!",
          author: "Priya R.",
        },
      },
      {
        id: "dental-3",
        title: "Dental Treatment Case 3 - Dental Implant Success Story",
        combined:
          "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Natural-looking teeth replacement. Excellent dental work!",
          author: "Suresh M.",
        },
      },
      {
        id: "dental-4",
        title: "Dental Treatment Case 4 - Orthodontic Treatment Excellence",
        combined:
          "https://images.unsplash.com/photo-1601568544619-9e77545a0c94?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Straight teeth with comfortable braces. Amazing results!",
          author: "Kavitha S.",
        },
      },
      {
        id: "dental-5",
        title: "Dental Treatment Case 5 - Root Canal Treatment Success",
        combined:
          "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Painless root canal treatment in Gerugambakkam. Saved my tooth!",
          author: "Ramesh P.",
        },
      },
      {
        id: "dental-6",
        title: "Dental Treatment Case 6 - Gum Treatment and Restoration",
        combined:
          "https://images.unsplash.com/photo-1542736667-069246bdbc6d?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Healthy gums restored with advanced laser treatment.",
          author: "Deepa L.",
        },
      },
      {
        id: "dental-7",
        title: "Dental Treatment Case 7 - Crown and Bridge Excellence",
        combined:
          "https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Perfect fit crowns with natural appearance achieved!",
          author: "Vikram R.",
        },
      },
      {
        id: "dental-8",
        title: "Dental Treatment Case 8 - Cosmetic Dentistry Transformation",
        combined:
          "https://images.unsplash.com/photo-1555708982-8645ec6618c7?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Complete smile transformation. Confidence fully restored!",
          author: "Anitha M.",
        },
      },
      {
        id: "dental-9",
        title: "Dental Treatment Case 9 - Pediatric Dentistry Success",
        combined:
          "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Child-friendly treatment approach. No more dental fear!",
          author: "Sita K.",
        },
      },
      {
        id: "dental-10",
        title: "Dental Treatment Case 10 - Full Mouth Rehabilitation Success",
        combined:
          "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Complete oral health restored. Life-changing dental results!",
          author: "Mahesh V.",
        },
      },
    ],

    homeopathy: [
      {
        id: "homeopathy-1",
        title: "Homeopathy Case 1 - PCOS Treatment Success in Gerugambakkam",
        combined:
          "https://images.unsplash.com/photo-1577003833619-76bbd7f82948?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Natural PCOS treatment regulated my cycles perfectly!",
          author: "Divya R.",
        },
      },
      {
        id: "homeopathy-2",
        title: "Homeopathy Case 2 - Chronic Illness Natural Healing",
        combined:
          "https://images.unsplash.com/photo-1505751171710-1f6d0ace5a85?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Holistic approach cured my chronic condition naturally.",
          author: "Raj M.",
        },
      },
      {
        id: "homeopathy-3",
        title: "Homeopathy Case 3 - Fertility Treatment Success Story",
        combined:
          "https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Blessed with a baby after homeopathic fertility treatment!",
          author: "Preethi S.",
        },
      },
      {
        id: "homeopathy-4",
        title: "Homeopathy Case 4 - Anxiety and Stress Management",
        combined:
          "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Mental peace achieved through natural homeopathic remedies.",
          author: "Arjun K.",
        },
      },
      {
        id: "homeopathy-5",
        title: "Homeopathy Case 5 - Digestive Health Restoration",
        combined:
          "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Digestive problems resolved without any side effects.",
          author: "Meera L.",
        },
      },
      {
        id: "homeopathy-6",
        title: "Homeopathy Case 6 - Skin Allergy Natural Treatment",
        combined:
          "https://images.unsplash.com/photo-1594824111567-8b5d7e0d5ad6?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Chronic skin allergies cured permanently with homeopathy!",
          author: "Sundar R.",
        },
      },
      {
        id: "homeopathy-7",
        title: "Homeopathy Case 7 - Respiratory Health Improvement",
        combined:
          "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Breathing problems resolved with gentle natural treatment.",
          author: "Lakshmi P.",
        },
      },
      {
        id: "homeopathy-8",
        title: "Homeopathy Case 8 - Joint Pain Relief Success",
        combined:
          "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Arthritis pain reduced significantly without medications.",
          author: "Raman V.",
        },
      },
      {
        id: "homeopathy-9",
        title: "Homeopathy Case 9 - Migraine Treatment Excellence",
        combined:
          "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Chronic migraines eliminated with homeopathic treatment.",
          author: "Kavya M.",
        },
      },
      {
        id: "homeopathy-10",
        title: "Homeopathy Case 10 - Overall Wellness Transformation",
        combined:
          "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Complete health transformation through natural healing methods.",
          author: "Deepak S.",
        },
      },
    ],
  };

  // Thumbnail flip state for autoplay
  const [thumbnailFlipState, setThumbnailFlipState] = useState({
    hair: Array(10).fill(false),
    skin: Array(10).fill(false),
    dental: Array(10).fill(false),
    homeopathy: Array(10).fill(false),
  });

  useEffect(() => {
    const timers = [];
    Object.keys(SAMPLE_GALLERY).forEach((svcKey) => {
      SAMPLE_GALLERY[svcKey].forEach((_, idx) => {
        const t = setInterval(() => {
          setThumbnailFlipState((prev) => {
            const copy = { ...prev };
            copy[svcKey] = copy[svcKey].slice();
            copy[svcKey][idx] = !copy[svcKey][idx];
            return copy;
          });
        }, 5000 + idx * 250);
        timers.push(t);
      });
    });
    return () => timers.forEach((t) => clearInterval(t));
  }, []);

  const openGerugambakkamBaModal = (serviceKey, startIndex = 0) => {
    setGerugambakkamBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setGerugambakkamBaModalStartIndex(startIndex);
    setGerugambakkamBaModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeGerugambakkamBaModal = () => {
    setGerugambakkamBaModalOpen(false);
    setGerugambakkamBaModalItems([]);
    setGerugambakkamBaModalStartIndex(0);
    document.body.style.overflow = "";
  };

  return (
    <>
      <SchemaMarkup />
      <div className="girukambakamchennai-hcura-chennai">
        {/* <section className="girukambakamchennai-hero" style={{ position: 'relative', overflow: 'hidden' }}>
  <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -2
    }}
  >
   <source src={hcuraHeroVideo} type="video/mp4" />
  </video>

  <div 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
      zIndex: -1
    }}
  ></div>

  <div className="girukambakamchennai-hero-content">
    <motion.h1
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="girukambakamchennai-main-heading"
    >
      H-Cura Multispecialty Clinic in Gerugambakkam Chennai
    </motion.h1>
    
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="girukambakamchennai-sub-heading"
    >
      Hair, Skin, Dental & Homeopathy Treatments for Women's Health
    </motion.h2>
    
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      className="girukambakamchennai-hero-description"
    >
      Welcome to H-Cura Multispecialty Clinic in Gerugambakkam – your trusted healthcare destination for advanced Hair Fall Treatment, Skin Whitening, Dental Care, and Natural Homeopathy.
      We specialize in women's health with expert PCOS/PCOD treatment, safe skin whitening, and natural healing solutions.
      Our clinic serves patients from Gerugambakkam, Porur, Mangadu, Moulivakkam, Iyyappanthangal, and surrounding areas with world-class care.
    </motion.p>
    
    <motion.div
      className="girukambakamchennai-hero-buttons"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
    >
      <Link to="/bookconsultation" className="girukambakamchennai-primary-button">Book Appointment</Link>
      <a href="https://wa.me/919964688333" className="girukambakamchennai-secondary-button" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp /> WhatsApp Consult
      </a>
    </motion.div>

    <motion.div
      className="girukambakamchennai-location-buttons"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.65 }}
    >
      <div className="location-header">
        <FaMapMarkerAlt className="location-icon" />
        <span>Our Other Locations</span>
      </div>
      
      <div className="location-nav-buttons">
        <Link to="/homeopathy-clinic-in-tambaram-chennai/" className="location-nav-btn">
          <FaDirections />
          <span>Tambaram</span>
        </Link>
        
        <Link to="/homeopathy-clinic-in-valasaravakkam-chennai/" className="location-nav-btn">
          <FaDirections />
          <span>Valasaravakkam</span>
        </Link>
        
        <Link to="/homeopathy-clinic-in-chennai/" className="location-nav-btn">
          <FaDirections />
          <span>Chennai Main</span>
        </Link>
      </div>
    </motion.div>

    <motion.div
      className="girukambakamchennai-clinic-location-tabs"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.7 }}
    >
    </motion.div>

    <motion.div
      className="girukambakamchennai-specialties-row"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.8 }}
    >
    </motion.div>
  </div>
</section> */}

        <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
          {/* Background Video */}
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -2
            }}
          >
           <source src={hcuraHeroVideo} type="video/mp4" />
          </video>
        
          {/* Video Overlay */}
          <div 
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
              zIndex: -1
            }}
          ></div>
        
          <div className="tambaram-hcura-hero-content-wrapper">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="tambaram-hcura-primary-title"
            >
             H-Cura Multispecialty Clinic in Gerugambakkam Chennai
            </motion.h1>
            
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="tambaram-hcura-secondary-title"
            >
              Expert Hair, Skin, Dental & Homeopathy Treatments
            </motion.h2>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="tambaram-hcura-description-text"
            >
              Welcome to H-Cura Multispecialty Clinic in Gerugambakkam – your trusted healthcare destination for advanced Hair Fall Treatment, Skin Whitening, Dental Care, and Natural Homeopathy. We specialize in women's health with expert PCOS/PCOD treatment, safe skin whitening, and natural healing solutions. Our clinic serves patients from Gerugambakkam, Porur, Mangadu, Moulivakkam, Iyyappanthangal, and surrounding areas with world-class care.
            </motion.p>
            
            <motion.div
              className="tambaram-hcura-action-buttons"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Appointment</Link>
              <a href="https://wa.me/918870001377" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp /> WhatsApp Consult
              </a>
            </motion.div>
        
            <motion.div
              className="tambaram-hcura-location-navigation"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.65 }}
            >
              <div className="tambaram-hcura-location-header">
                <FaMapMarkerAlt className="tambaram-hcura-location-icon" />
                <span className="tambaram-hcura-location-title">Our Chennai Locations</span>
              </div>
              
              <div className="tambaram-hcura-location-buttons">
                <Link to="/multispecialty-clinic-in-tambaram-chennai" className="tambaram-hcura-location-btn">
                  <FaDirections />
                  <span>Tambaram</span>
                </Link>
                
                <Link to="/homeopathy-clinic-in-valasaravakkam-chennai/" className="tambaram-hcura-location-btn">
                  <FaDirections />
                  <span>Valasaravakkam</span>
                </Link>
                
                <Link to="/multispecialty-clinic-in-chennai/" className="tambaram-hcura-location-btn">
                  <FaDirections />
                  <span>Back</span>
                </Link>
              </div>
            </motion.div>
          </div>
        </section>

        {/* DOCTORS */}
        {/* <section id="doctors" className="girukambakamchennai-doctors">
          <div className="girukambakamchennai-section-header">
            <span className="girukambakamchennai-section-subtitle">Meet Our Expert Team</span>
            <h2>Our Specialist Doctors in Gerugambakkam</h2>
            <div className="girukambakamchennai-decorative-line"><span className="girukambakamchennai-decorative-icon"><FaUserMd /></span></div>
            <p className="girukambakamchennai-section-description">Our experienced team of specialists — dermatologists, trichologists, dentists and homeopaths — deliver personalized care with modern diagnostics and compassionate follow-up.</p>
          </div>

          <div className="girukambakamchennai-doctors-grid">
            {[
              { name: "Dr. A. Ramesh", title: "Dermatologist", qualifications: "MD (Dermatology), Cosmetology", experience: "12 years", image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=800&auto=format&fit=crop", specialties: ["Acne & Pigmentation", "Skin Whitening"] },
              { name: "Dr. S. Priya", title: "Trichologist", qualifications: "DNB (Dermatology), Tricho", experience: "10 years", image: "https://images.unsplash.com/photo-1550831107-1553da8c8464?q=80&w=800&auto=format&fit=crop", specialties: ["PRP & GFC Hair Treatment", "Hair Transplants"] },
              { name: "Dr. K. Vinod", title: "Dental Surgeon", qualifications: "MDS (Prosthodontics)", experience: "9 years", image: "https://images.unsplash.com/photo-1580281657521-1d5f5b61f4a7?q=80&w=800&auto=format&fit=crop", specialties: ["Dental Implants", "Root Canal"] },
              { name: "Dr. N. Shalini", title: "Homeopath", qualifications: "BHMS", experience: "15 years", image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=800&auto=format&fit=crop", specialties: ["PCOS/PCOD Treatment", "Women's Health"] }
            ].map((doc, i) => (
              <motion.article key={i} className="girukambakamchennai-doctor-card" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12 }} aria-labelledby={`doctor-${i}-name`}>
                <div className="girukambakamchennai-doctor-media" style={{ backgroundImage: `url('${doc.image}')` }} role="img" aria-label={`${doc.name} photo`} />
                <div className="girukambakamchennai-doctor-body">
                  <h3 id={`doctor-\${i}-name`}>{doc.name}</h3>
                  <p className="girukambakamchennai-doctor-title">{doc.title} • {doc.qualifications}</p>
                                  <p className="girukambakamchennai-doctor-exp">{doc.experience} experience</p>
                  <ul className="girukambakamchennai-doctor-specialties">{doc.specialties.map((s, si) => <li key={si}><FaCheckCircle className="girukambakamchennai-doctor-check" /> {s}</li>)}</ul>
                  <div className="girukambakamchennai-doctor-cta">
                    <Link to="/bookconsultation" className="girukambakamchennai-doctor-book">Book with {doc.name.split(' ')[1]}</Link>
                    <a href={`https://wa.me/919964688333?text=Hi%20I%20want%20to%20book%20an%20appointment%20with%20${encodeURIComponent(doc.name)}`} className="girukambakamchennai-doctor-whatsapp" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp</a>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </section> */}

        {/* BEFORE & AFTER - Clean Single Images Only */}
        <section id="before-after" className="girukambakamchennai-before-after">
          <div className="girukambakamchennai-section-header">
            <span className="girukambakamchennai-section-subtitle">
              Real Results
            </span>
            <h2>Before & After Gallery - Gerugambakkam</h2>
            <div className="girukambakamchennai-decorative-line">
              <span className="girukambakamchennai-decorative-icon">
                <FaArrowRight />
              </span>
            </div>
            <p className="girukambakamchennai-section-description">
              Genuine patient transformations from our Gerugambakkam clinic —
              each image shows complete before and after comparison. Click View
              Details for full gallery.
            </p>
          </div>

          <div className="girukambakamchennai-before-tabs">
            {["hair", "skin"].map((s, idx) => (
              <button
                key={s}
                className={`girukambakamchennai-ba-tab ${
                  activeService === idx ? "active" : ""
                }`}
                onClick={() => {
                  handleServiceChange(idx);
                  setIsAutoScrollPaused(true);
                  setTimeout(() => setIsAutoScrollPaused(false), 10000);
                }}
                aria-pressed={activeService === idx}
              >
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            ))}
          </div>

          <div className="girukambakamchennai-before-carousel-wrapper">
            <div
              className="girukambakamchennai-before-carousel"
              role="list"
              aria-label="Before after gallery"
            >
              {(() => {
                const svcKey = activeService === 0 ? "hair" : "skin";
                const items = SAMPLE_GALLERY[svcKey] || [];

                return items.map((item, idx) => (
                  <article
                    key={item.id}
                    className="girukambakamchennai-ba-clean-card"
                    role="listitem"
                  >
                    <div className="girukambakamchennai-ba-clean-container">
                      <div className="girukambakamchennai-ba-clean-image-wrapper">
                        <img
                          src={item.combined}
                          alt={`${item.title} transformation results at H-Cura Gerugambakkam`}
                          className="girukambakamchennai-ba-clean-image"
                          title={`${item.title} - Before and After Treatment Results`}
                        />
                        <div className="girukambakamchennai-ba-clean-title">
                          <h4>{item.title}</h4>
                        </div>
                      </div>
                      <div className="girukambakamchennai-ba-clean-actions">
                        <button
                          className="girukambakamchennai-ba-clean-view-btn"
                          onClick={() => openGerugambakkamBaModal(svcKey, idx)}
                          aria-label={`View detailed results for ${item.title}`}
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  </article>
                ));
              })()}
            </div>
          </div>
        </section>

        {/* Modal viewer for detailed view with scrolling */}
        {gerugambakkamBaModalOpen && (
          <div
            className="girukambakamchennai-ba-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Before and after detailed gallery"
          >
            <div
              className="girukambakamchennai-ba-modal-backdrop"
              onClick={closeGerugambakkamBaModal}
            />
            <div className="girukambakamchennai-ba-modal-panel">
              <header className="girukambakamchennai-ba-modal-header">
                <h3>Treatment Results Gallery - H-Cura Gerugambakkam</h3>
                <button
                  className="girukambakamchennai-ba-modal-close"
                  onClick={closeGerugambakkamBaModal}
                  aria-label="Close gallery"
                >
                  ×
                </button>
              </header>

              <div className="girukambakamchennai-ba-modal-body">
                <div className="girukambakamchennai-ba-scrollable-container">
                  <div
                    className="girukambakamchennai-ba-scroll-track"
                    id="scrollTrack"
                  >
                    <div
                      className="girukambakamchennai-ba-scrollable-grid"
                      id="scrollableGrid"
                    >
                      {gerugambakkamBaModalItems.map((item, index) => (
                        <div
                          key={item.id}
                          className="girukambakamchennai-ba-scrollable-card"
                          data-index={index}
                        >
                          <div className="girukambakamchennai-ba-scrollable-image-container">
                            <img
                              src={item.combined}
                              alt={`${item.title} detailed view - H-Cura Gerugambakkam results`}
                              className="girukambakamchennai-ba-scrollable-image"
                              title={`${item.title} - Complete Treatment Results`}
                            />
                          </div>
                          <div className="girukambakamchennai-ba-scrollable-content">
                            <h4>{item.title}</h4>
                            <p className="girukambakamchennai-ba-scrollable-testimonial">
                              "{item.testimonial?.quote || ""}"
                            </p>
                            <div className="girukambakamchennai-ba-scrollable-author">
                              — {item.testimonial?.author || ""}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Scroll Progress Bar */}
                  <div className="girukambakamchennai-ba-scroll-progress">
                    <div
                      className="girukambakamchennai-ba-progress-bar"
                      id="progressBar"
                    ></div>
                  </div>
                </div>

                {/* Enhanced Navigation Controls */}
                <div className="girukambakamchennai-ba-enhanced-controls">
                  <div className="girukambakamchennai-ba-nav-buttons">
                    <button
                      className="girukambakamchennai-ba-nav-btn girukambakamchennai-ba-prev-btn"
                      id="prevBtn"
                      onClick={() => scrollGallery("prev")}
                      aria-label="Previous results"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                      </svg>
                      Previous
                    </button>

                    <button
                      className="girukambakamchennai-ba-nav-btn girukambakamchennai-ba-next-btn"
                      id="nextBtn"
                      onClick={() => scrollGallery("next")}
                      aria-label="Next results"
                    >
                      Next
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* WHY CHOOSE */}
        <section
          id="why-choose"
          className="girukambakamchennai-why-choose-enhanced"
        >
          <div className="girukambakamchennai-curved-background">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#ffffff"
                fillOpacity="1"
                d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              ></path>
            </svg>
          </div>

          <div className="girukambakamchennai-content-wrapper">
            <motion.div
              className="girukambakamchennai-section-header"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <span className="girukambakamchennai-section-subtitle">
                Excellence in Healthcare
              </span>
              <h2>Why Choose H-Cura Clinic in Gerugambakkam Chennai?</h2>
              <div className="girukambakamchennai-decorative-line">
                <span className="girukambakamchennai-decorative-icon">
                  <FaShieldAlt />
                </span>
              </div>
              <p className="girukambakamchennai-section-description">
                Because your health, beauty, and confidence deserve a clinic
                that truly cares. At H-Cura Gerugambakkam, we bring together
                specialist doctors, world-class technology, and a patient-first
                approach to give you the best possible results. Whether it's
                restoring your hair, brightening your skin, enhancing your
                smile, or improving your overall wellness with homeopathy, we
                focus on treatments that are safe, effective, and tailored just
                for you. Conveniently located in Gerugambakkam for residents of
                Porur, Mangadu, Moulivakkam, and surrounding areas, we make
                advanced healthcare accessible, comfortable, and trustworthy —
                so you can step in with hope and step out with confidence.
              </p>
            </motion.div>

            <div className="girukambakamchennai-awards-banner">
              <div className="girukambakamchennai-award">
                <FaStar className="girukambakamchennai-award-icon" />
                <span>Best Dermatology Clinic 2024</span>
              </div>
              <div className="girukambakamchennai-award">
                <FaCertificate className="girukambakamchennai-award-icon" />
                <span>ISO 9001:2015 Certified</span>
              </div>
              <div className="girukambakamchennai-award">
                <FaAward className="girukambakamchennai-award-icon" />
                <span>Top Healthcare Provider</span>
              </div>
            </div>

            <motion.div
              className="girukambakamchennai-features-grid"
              ref={whyChooseRef}
              variants={containerVariants}
              initial="hidden"
              animate={whyChooseControls}
            >
              {features.map((feature, index) => (
                <motion.div
                  className="girukambakamchennai-feature-card-enhanced"
                  key={index}
                  variants={itemVariants}
                >
                  <div className="girukambakamchennai-feature-header">
                    <div className="girukambakamchennai-icon-container">
                      {feature.icon}
                      <div className="girukambakamchennai-icon-glow"></div>
                    </div>
                    <span className="girukambakamchennai-feature-highlight">
                      {feature.highlight}
                    </span>
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                  <div className="girukambakamchennai-feature-footer">
                    <div className="girukambakamchennai-feature-dots">
                      <span className="girukambakamchennai-dot"></span>
                      <span className="girukambakamchennai-dot"></span>
                      <span className="girukambakamchennai-dot"></span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            <div className="girukambakamchennai-testimonial-strip">
              <div className="girukambakamchennai-testimonial-background"></div>
              <div className="girukambakamchennai-testimonial-content">
                <div className="girukambakamchennai-quote-marks">"</div>
                <div className="girukambakamchennai-testimonial-slider">
                  {testimonialQuotes.map((quote, index) => (
                    <div
                      className="girukambakamchennai-testimonial-quote"
                      key={index}
                    >
                      <p>{quote}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="girukambakamchennai-stats-container">
              <div className="girukambakamchennai-stat-box">
                <div className="girukambakamchennai-stat-number">15+</div>
                <div className="girukambakamchennai-stat-label">
                  Years of Excellence
                </div>
              </div>
              <div className="girukambakamchennai-stat-box">
                <div className="girukambakamchennai-stat-number">30+</div>
                <div className="girukambakamchennai-stat-label">
                  Medical Experts
                </div>
              </div>
              <div className="girukambakamchennai-stat-box">
                <div className="girukambakamchennai-stat-number">10k+</div>
                <div className="girukambakamchennai-stat-label">
                  Happy Patients
                </div>
              </div>
              <div className="girukambakamchennai-stat-box">
                <div className="girukambakamchennai-stat-number">95%</div>
                <div className="girukambakamchennai-stat-label">
                  Success Rate
                </div>
              </div>
            </div>

            <div className="girukambakamchennai-cta-container">
              <h3>Experience the H-Cura Gerugambakkam Difference</h3>
              <p>
                Join thousands of satisfied patients who have transformed their
                lives with our expert care in Gerugambakkam.
              </p>
              <Link
                to="/bookconsultation"
                className="girukambakamchennai-cta-button"
              >
                Book Your Consultation
              </Link>
            </div>
          </div>

          <div className="girukambakamchennai-curved-background-bottom">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#ffffff"
                fillOpacity="1"
                d="M0,160L48,181.3C96,203,192,245,288,229.3C384,213,480,139,576,128C672,117,768,171,864,197.3C960,224,1056,224,1152,213.3C1248,203,1344,181,1392,170.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
              ></path>
            </svg>
          </div>
        </section>

        <section
          id="services"
          className="girukambakamchennai-services-premium-section"
          ref={sectionRef}
        >
          <div
            className={`girukambakamchennai-services-background ${
              isVisible ? "visible" : ""
            }`}
            style={{
              backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundAttachment: "fixed",
              opacity: isVisible ? 1 : 0,
            }}
          ></div>

          <div className="girukambakamchennai-services-container">
            <div
              className={`girukambakamchennai-services-header ${
                isVisible ? "visible" : ""
              }`}
            >
              <span className="girukambakamchennai-services-subtitle">
                Excellence in Healthcare
              </span>
              <h2>Our Services at H-Cura Gerugambakkam</h2>
              <div className="girukambakamchennai-services-separator">
                <span></span>
                <div className="girukambakamchennai-separator-icon"></div>
                <span></span>
              </div>
              <p className="girukambakamchennai-services-description">
                Experience world-class treatments delivered with precision and
                care. Our comprehensive range of services combines advanced
                medical technology with natural healing approaches, specializing
                in women's health and wellness.
              </p>
            </div>

            <div
              className={`girukambakamchennai-services-tabs ${
                isVisible ? "visible" : ""
              }`}
              ref={servicesRef}
              onMouseEnter={() => setIsAutoScrollPaused(true)}
              onMouseLeave={() => setIsAutoScrollPaused(false)}
              onFocus={() => setIsAutoScrollPaused(true)}
              onBlur={() => setIsAutoScrollPaused(false)}
            >
              {advancedServices.map((service, index) => {
                const sIcon = serviceIconMap[service.id] || null;
                const isActive = activeService === index;
                return (
                  <button
                    key={service.id}
                    className={`girukambakamchennai-service-tab ${
                      isActive ? "active" : ""
                    }`}
                    onClick={() => {
                      setIsAutoScrollPaused(true);
                      handleServiceChange(index);
                      setTimeout(() => setIsAutoScrollPaused(false), 10000);
                    }}
                  >
                    <span
                      className={`girukambakamchennai-tab-icon girukambakamchennai-${service.id}-icon bright-icon`}
                      style={{
                        backgroundImage: sIcon
                          ? `url('${sIcon.url}')`
                          : undefined,
                        backgroundSize: "60% auto",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundColor: sIcon ? sIcon.bgColor : undefined,
                        border: sIcon
                          ? `2px solid ${sIcon.borderColor}`
                          : undefined,
                        width: "44px",
                        height: "44px",
                        borderRadius: "12px",
                        display: "inline-block",
                      }}
                    ></span>
                    <span className="girukambakamchennai-tab-text">
                      {service.title.split(" ")[0]}
                    </span>
                    {isActive && (
                      <span className="girukambakamchennai-progress-bar"></span>
                    )}
                  </button>
                );
              })}
            </div>

            <div className="girukambakamchennai-tab-indicators">
              {advancedServices.map((service, index) => (
                <span
                  key={`indicator-${index}`}
                  className={`girukambakamchennai-tab-indicator ${
                    activeService === index ? "active" : ""
                  }`}
                  onClick={() => {
                    setIsAutoScrollPaused(true);
                    handleServiceChange(index);
                    setTimeout(() => setIsAutoScrollPaused(false), 10000);
                  }}
                ></span>
              ))}
            </div>

            <div
              className={`girukambakamchennai-service-content-wrapper ${
                isVisible ? "visible" : ""
              }`}
            >
              <div
                className={`girukambakamchennai-service-main-content ${
                  isChanging ? "changing" : ""
                }`}
              >
                <div className="girukambakamchennai-service-info">
                  <h3>{advancedServices[activeService].title}</h3>
                  <h4>{advancedServices[activeService].subtitle}</h4>
                  <p>{advancedServices[activeService].description}</p>

                  <div className="girukambakamchennai-service-cta">
                    <Link
                      to="/bookconsultation"
                      className="girukambakamchennai-service-btn"
                    >
                      Book Consultation
                    </Link>
                    <Link
                      to={serviceLearnMoreUrl(
                        advancedServices[activeService].id
                      )}
                      className="girukambakamchennai-service-link"
                    >
                      Learn More{" "}
                      <span className="girukambakamchennai-arrow-icon">→</span>
                    </Link>
                  </div>
                </div>

                <div className="girukambakamchennai-service-image-container">
                  <div className="girukambakamchennai-service-image-wrapper">
                    <img
                      src={advancedServices[activeService].image}
                      alt={`${advancedServices[activeService].title} at H-Cura Gerugambakkam`}
                      className="girukambakamchennai-service-main-image"
                      title={`${advancedServices[activeService].title} - Advanced Treatment in Gerugambakkam`}
                    />
                    <div className="girukambakamchennai-image-overlay"></div>
                    <div className="girukambakamchennai-service-badge">
                      <span>Premium Care</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="girukambakamchennai-service-treatments">
                <h4>Specialized Treatments in Gerugambakkam</h4>
                <div className="girukambakamchennai-treatments-slider">
                  {advancedServices[activeService].treatments.map(
                    (treatment, tIndex) => {
                      const tIcon = treatmentIconMap[treatment.icon] || null;
                      return (
                        <div
                          className="girukambakamchennai-treatment-card"
                          key={tIndex}
                        >
                          <div className="girukambakamchennai-treatment-image">
                            <img
                              src={treatment.image}
                              alt={`${treatment.name} at H-Cura Gerugambakkam`}
                              title={`${treatment.name} - Expert Treatment in Gerugambakkam`}
                            />
                          </div>
                          <div className="girukambakamchennai-treatment-content">
                            <div
                              className={`girukambakamchennai-treatment-icon girukambakamchennai-${treatment.icon} bright-treatment-icon`}
                              style={{
                                backgroundImage: tIcon
                                  ? `url('${tIcon.url}')`
                                  : undefined,
                                backgroundSize: "60% auto",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundColor: tIcon
                                  ? tIcon.bgColor
                                  : undefined,
                                border: tIcon
                                  ? `2px solid ${tIcon.borderColor}`
                                  : undefined,
                                width: "56px",
                                height: "56px",
                                borderRadius: "12px",
                              }}
                            ></div>
                            <h5>{treatment.name}</h5>
                            <p>{treatment.description}</p>
                            <div className="girukambakamchennai-treatment-benefits">
                              <h6>Benefits:</h6>
                              <ul>
                                {treatment.benefits.map((benefit, i) => (
                                  <li key={i}>
                                    <span className="girukambakamchennai-benefit-icon">
                                      ✓
                                    </span>
                                    {benefit}
                                  </li>
                                ))}
                              </ul>
                            </div>

                            <div className="girukambakamchennai-treatment-cta">
                              <Link
                                className="girukambakamchennai-treatment-learnmore"
                                to={serviceLearnMoreUrl(
                                  advancedServices[activeService].id
                                )}
                              >
                                Learn More
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>

              <div className="girukambakamchennai-service-testimonial">
                <div className="girukambakamchennai-testimonial-content">
                  <div className="girukambakamchennai-quote-icon">"</div>
                  <p>{advancedServices[activeService].testimonial.quote}</p>
                  <div className="girukambakamchennai-testimonial-author">
                    <strong>
                      {advancedServices[activeService].testimonial.author}
                    </strong>{" "}
                    | {advancedServices[activeService].testimonial.location}
                  </div>
                </div>
                <div className="girukambakamchennai-testimonial-decoration"></div>
              </div>

              <div className="girukambakamchennai-service-stats">
                <div className="girukambakamchennai-stat-item">
                  <div className="girukambakamchennai-stat-number">
                    98<span>%</span>
                  </div>
                  <div className="girukambakamchennai-stat-label">
                    Patient Satisfaction
                  </div>
                </div>
                <div className="girukambakamchennai-stat-item">
                  <div className="girukambakamchennai-stat-number">
                    5000<span>+</span>
                  </div>
                  <div className="girukambakamchennai-stat-label">
                    Successful Treatments
                  </div>
                </div>
                <div className="girukambakamchennai-stat-item">
                  <div className="girukambakamchennai-stat-number">
                    15<span>+</span>
                  </div>
                  <div className="girukambakamchennai-stat-label">
                    Years Experience
                  </div>
                </div>
                <div className="girukambakamchennai-stat-item">
                  <div className="girukambakamchennai-stat-number">
                    12<span>+</span>
                  </div>
                  <div className="girukambakamchennai-stat-label">
                    Specialist Doctors
                  </div>
                </div>
              </div>

              <div className="girukambakamchennai-service-features">
                <div className="girukambakamchennai-feature">
                  <div
                    className="girukambakamchennai-feature-icon girukambakamchennai-quality-icon"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    aria-hidden
                  >
                    <Icon name="quality-icon" size={28} />
                  </div>
                  <h5>Premium Quality</h5>
                  <p>World-class treatments and technologies</p>
                </div>

                <div className="girukambakamchennai-feature">
                  <div
                    className="girukambakamchennai-feature-icon girukambakamchennai-personalized-icon"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    aria-hidden
                  >
                    <Icon name="personalized-icon" size={28} />
                  </div>
                  <h5>Personalized Care</h5>
                  <p>Customized treatment plans for each patient</p>
                </div>

                <div className="girukambakamchennai-feature">
                  <div
                    className="girukambakamchennai-feature-icon girukambakamchennai-affordable-icon"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    aria-hidden
                  >
                    <Icon name="affordable-icon" size={28} />
                  </div>
                  <h5>Affordable Excellence</h5>
                  <p>Premium care at reasonable prices</p>
                </div>
              </div>

              <div className="girukambakamchennai-service-action">
                <h4>
                  Ready to Experience the H-Cura Gerugambakkam Difference?
                </h4>
                <p>
                  Take the first step toward better health and confidence today.
                </p>
                <div className="girukambakamchennai-action-buttons">
                  <Link
                    to="/bookconsultation"
                    className="girukambakamchennai-primary-action-btn"
                  >
                    Book Appointment
                  </Link>
                  <Link
                    to="/contact-us"
                    className="girukambakamchennai-secondary-action-btn"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>

              <div
                className={`girukambakamchennai-services-partners \${isVisible ? 'visible' : ''}`}
              >
                <h4>Our Technology Partners</h4>
                <div className="girukambakamchennai-partners-logos">
                  <div
                    className="girukambakamchennai-partner-logo"
                    style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                  ></div>
                  <div
                    className="girukambakamchennai-partner-logo"
                    style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                  ></div>
                  <div
                    className="girukambakamchennai-partner-logo"
                    style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                  ></div>
                  <div
                    className="girukambakamchennai-partner-logo"
                    style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                  ></div>
                  <div
                    className="girukambakamchennai-partner-logo"
                    style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="girukambakamchennai-stats-banner">
          <div className="girukambakamchennai-stat">
            <h3>10,000+</h3>
            <p>Happy Patients</p>
          </div>
          <div className="girukambakamchennai-stat">
            <h3>15+</h3>
            <p>Years of Excellence</p>
          </div>
          <div className="girukambakamchennai-stat">
            <h3>30+</h3>
            <p>Specialist Doctors</p>
          </div>
          <div className="girukambakamchennai-stat">
            <h3>3</h3>
            <p>Convenient Locations</p>
          </div>
        </section>

       <section id="locations" className="girukambakamchennai-locations">
  <div className="girukambakamchennai-section-header">
    <h2>Our Clinic Locations in Chennai</h2>
    <p>Find the nearest H-Cura clinic for your healthcare needs</p>
  </div>

  <div className="girukambakamchennai-location-tabs">
    <Link
      to="/homeopathy-clinic-in-valasaravakkam-chennai/"
      className={`girukambakamchennai-location-tab ${
        activeLocation === "valasaravakkam" ? "active" : ""
      }`}
    >
      <FaMapMarkerAlt /> Valasaravakkam
    </Link>
    
    <Link
      to="/multispecialty-clinic-in-gerugambakkam-chennai"
      className={`girukambakamchennai-location-tab ${
        activeLocation === "gerugambakkam" ? "active" : ""
      }`}
    >
      <FaMapMarkerAlt /> Gerugambakkam
    </Link>
    
    <Link
      to="/multispecialty-clinic-in-tambaram-chennai"
      className={`girukambakamchennai-location-tab ${
        activeLocation === "tambaram" ? "active" : ""
      }`}
    >
      <FaMapMarkerAlt /> Tambaram
    </Link>
  </div>

  <div className="girukambakamchennai-location-details">
    <div className="girukambakamchennai-location-card">
      <div className="girukambakamchennai-location-header">
        <h3>{locations[activeLocation].name} Branch</h3>
        <span className="girukambakamchennai-specialty-tag">
          {locations[activeLocation].specialties}
        </span>
      </div>

      <div className="girukambakamchennai-location-grid">
        <div className="girukambakamchennai-location-info">
          <div className="girukambakamchennai-info-item">
            <FaMapMarkerAlt className="girukambakamchennai-info-icon" />
            <div>
              <h4>Address</h4>
              <p>{locations[activeLocation].address}</p>
              <p>
                <small>
                  Nearby: {locations[activeLocation].nearbyAreas}
                </small>
              </p>
            </div>
          </div>

          <div className="girukambakamchennai-info-item">
            <FaPhone className="girukambakamchennai-info-icon" />
            <div>
              <h4>Contact</h4>
              <p>{locations[activeLocation].phone}</p>
              <button
                className="girukambakamchennai-contact-button"
                onClick={() =>
                  (window.location.href = `tel:${locations[
                    activeLocation
                  ].phone.replace(/\s+/g, "")}`)
                }
              >
                Call Now
              </button>
            </div>
          </div>

          <div className="girukambakamchennai-info-item">
            <FaClock className="girukambakamchennai-info-icon" />
            <div>
              <h4>Working Hours</h4>
              <p>{locations[activeLocation].hours}</p>
            </div>
          </div>
        </div>

        <div className="girukambakamchennai-popular-services">
          <h4>Popular Services at {locations[activeLocation].name}</h4>
          <ul>
            {locations[activeLocation].popularServices.map(
              (service, index) => (
                <li key={index}>
                  <FaCheckCircle className="girukambakamchennai-check-icon" />
                  {service}
                </li>
              )
            )}
          </ul>
          <a
            href={locations[activeLocation].mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="girukambakamchennai-map-link"
          >
            View on Map <FaArrowRight />
          </a>
        </div>
      </div>
    </div>

    <div className="girukambakamchennai-location-image">
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      >
        <source
          src={
            locations[activeLocation].video ||
            locations[activeLocation].image
          }
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</section>



        <section id="testimonials" className="girukambakamchennai-testimonials">
          <div className="girukambakamchennai-section-header">
            <h2>What Our Gerugambakkam Patients Say</h2>
            <p>
              Real experiences from our valued patients in Gerugambakkam and
              surrounding areas
            </p>
          </div>
          <div className="girukambakamchennai-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <motion.div
                className="girukambakamchennai-testimonial-card"
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <div className="girukambakamchennai-testimonial-rating">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className={
                        i < testimonial.rating
                          ? "girukambakamchennai-star-filled"
                          : "girukambakamchennai-star-empty"
                      }
                    />
                  ))}
                </div>
                <p className="girukambakamchennai-testimonial-text">
                  "{testimonial.text}"
                </p>
                <div className="girukambakamchennai-testimonial-author">
                  <div
                    className="girukambakamchennai-author-info"
                    title={`${testimonial.name} • ${testimonial.location} • ${testimonial.service}`}
                  >
                    <h4 className="girukambakamchennai-testimonial-name">
                      {testimonial.name}
                    </h4>
                    <p className="girukambakamchennai-testimonial-meta">
                      {testimonial.location} • {testimonial.service}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        <section
          id="appointment"
          className="girukambakamchennai-appointment"
          style={{
            position: "relative",
            overflow: "hidden",
            color: "#fff",
          }}
        >
          {/* Background Video */}
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: -2,
            }}
          >
            <source src={hcuraHeroVideo2} type="video/mp4" />
          </video>

          {/* Video Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65))",
              zIndex: -1,
            }}
          ></div>

          <div
            className="girukambakamchennai-appointment-content"
            role="region"
            aria-labelledby="appointment-heading"
          >
            <motion.h2
              id="appointment-heading"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              Book Your Appointment at H-Cura Gerugambakkam Today
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              Take the first step toward better health and confidence. Schedule
              your visit with H-Cura Multispecialty Clinic in Gerugambakkam,
              Chennai.
            </motion.p>

            <motion.div
              className="girukambakamchennai-contact-options"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              <div className="girukambakamchennai-contact-option">
                <FaPhone /> <span>+91 99646 88333</span>
              </div>
              <div className="girukambakamchennai-contact-option">
                <FaGlobe />{" "}
                <a
                  href="https://h-cura.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.h-cura.com
                </a>
              </div>
            </motion.div>

            <motion.div
              className="girukambakamchennai-appointment-buttons"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <Link
                to="/bookconsultation"
                className="girukambakamchennai-primary-button"
              >
                Schedule Consultation
              </Link>
              <a
                href="https://wa.me/919964688333"
                className="girukambakamchennai-whatsapp-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp /> WhatsApp Us
              </a>
            </motion.div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HCuraChennai;
